import { TAB_TITLE_TRENDS, HOME_LONG_PATH } from '@utils/constants';
import getActualShareLink from '@components/common/Sharing/SharingModal/SharingContent/getActualShareLink';

// eslint-disable-next-line import/prefer-default-export
export function setDefaultLandingPageWhenEmpty(obj, cid) {
  const clone = { ...obj };
  if (clone.path === '' || clone.path == null || clone.url === '' || clone.url == null) {
    clone.path = HOME_LONG_PATH;
    clone.url = getActualShareLink(HOME_LONG_PATH, cid);
    clone.name = TAB_TITLE_TRENDS;
  }
  return clone;
}
